import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Load developer tools (accessible via window.devTools in console)
import './utils/devTools';
import { initVersionGuard, initChunkReloadGuard } from './utils/versionGuard';
import { applyTheme, SLIK_THEME } from './theme/branding';


// Silence noisy dev logs in production; keep console.error/warn for real diagnostics.
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = console.info = console.debug = () => {};
}

// Self-heal: auto-reload when a newer build is deployed (kills stale mobile-Safari cache).
initVersionGuard();

// Apply the SLIK brand theme (Warm Barbershop) before first paint. BEHAVIOR-PIN:
// runtime theme engine — swap SLIK_THEME for a per-tenant theme (from Settings /
// Firestore shop config) to rebrand the whole staff app. See src/theme/branding.ts.
applyTheme(SLIK_THEME);
// Then load this shop's SAVED theme (brand color + per-element tones) and apply it once ready.
// Non-blocking: SLIK default paints first, the saved theme retints when it resolves. (Phase 2)
import('./theme/themeRuntime').then((m) => m.loadThemeFromSettings());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out the instant pre-React splash (public/index.html #slik-splash) once React has taken
// over. Double-rAF so React has painted its identical <SlikLoader fullScreen> underneath first —
// the hand-off is invisible. (Jose 2026-09-25 branded splash.)
const splashEl = document.getElementById('slik-splash');
if (splashEl) {
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      splashEl.style.opacity = '0';
      setTimeout(() => splashEl.remove(), 550);
    })
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
